<div class="flex gap-[10px] items-center">
    <a [routerLink]="['/cart'] | localize" *ngIf="!isCartEmpty" class="uppercase font-bold"><img src="/assets/images/cart.png" class="w-[20px] h-[20px]"></a>
    <a [routerLink]="['/cart'] | localize" *ngIf="isCartEmpty" class="uppercase font-bold"><img src="/assets/images/cartempty.png" class="w-[20px] h-[20px]"></a>
    <span class="select-none font-bold text-xs" *ngIf="remainingTime !== undefined">{{ remainingTime }}</span>
</div>